import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=c6c19832&scoped=true&"
import script from "./page-header.vue?vue&type=script&lang=ts&"
export * from "./page-header.vue?vue&type=script&lang=ts&"
import style0 from "./page-header.vue?vue&type=style&index=0&id=c6c19832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c19832",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBreadcrumbs,VBtn,VContainer,VIcon})
